<template>
    <div class="container-xxl padding-container-matrix-sm">
        <div class="row justify-content-center">
            <div class="col-matrix">
                <div class="text-editor text-editor-card" :class="backgroundColor">
                    <div class="text-editor" v-html="textEditor"></div>
                    <div v-if="sectionLink">
                        <a
                            v-if="sectionLinkType == 'email'"
                            :href="'mailto:' + sectionLink"
                            class="link-arrow right bold text-red mb-3 d-block"
                            target="_blank"
                        >
                            <span v-if="sectionLinkText != null">{{ sectionLinkText }}</span>
                        </a>
                        <a
                            v-else-if="sectionLinkType == 'entry'"
                            :href="sectionLink.fr"
                            class="link-arrow right bold text-red mb-3 d-block"
                        >
                            <span v-if="sectionLinkText != null">{{ sectionLinkText }}</span>
                        </a>
                        <a
                            v-else-if="sectionLinkType == 'url'"
                            :href="sectionLink"
                            class="link-arrow right bold text-red mb-3 d-block"
                            target="_blank"
                        >
                            <span v-if="sectionLinkText != null">{{ sectionLinkText }}</span>
                        </a>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import { mapState, mapGetters, mapActions } from 'vuex'
// import AssetLoader from '@/components/helpers/AssetLoader'

export default {
    name: 'textHighlight',
    components: {
        // AssetLoader
    },
    props: {
        backgroundColor: {
            type: String,
            required: true,
        },
        textEditor: {
            type: String,
            required: true,
        },
        sectionLink: {
            type: Object,
            required: false,
        },
        sectionLinkText: {
            type: String,
            required: false,
        },
        sectionLinkType: {
            type: String,
            required: false,
        },
    },
    computed: {
        pageIsLoaded() {
            return this.contentIsLoaded && this.globalsIsLoaded
        },
        ...mapState(['contentIsLoaded', 'globalsIsLoaded']),
        ...mapGetters(['seo', 'content', 'globals']),
    },
    methods: {
        ...mapActions(['setErrorsReportMsg']),
    },
    // On loaded...
    mounted() {},
}
</script>
